"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6808,8120],{

/***/ 897009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Image/index.js + 2 modules
var Image = __webpack_require__(606665);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/analytics.js + 1 modules
var analytics = __webpack_require__(60368);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(320129);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/helpers.js

var ImageTokens = Components/* tokens.image */.T.image, getBorderRadiusByVariant = function(variant, orientation) {
    switch(variant){
        case "arch":
            return {
                borderTopLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderTopRightRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomLeftRadius: ImageTokens.radius.imageCornerRadius["16x"],
                borderBottomRightRadius: ImageTokens.radius.imageCornerRadius["16x"]
            };
        case "circle":
            return {
                borderTopLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderTopRightRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomRightRadius: ImageTokens.radius.imageCornerRadius.full
            };
        case "article":
            return {
                borderTopLeftRadius: orientation === "top" || orientation === "left" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderTopRightRadius: orientation === "top" || orientation === "right" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderBottomLeftRadius: orientation === "bottom" || orientation === "left" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderBottomRightRadius: orientation === "bottom" || orientation === "right" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"]
            };
        default:
            break;
    }
};


// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js










var BaseImageReactNative = (0,cjs.styled)(Image/* default */.Z, {
    name: "Image",
    variants: {
        variant: function(variant, extras) {
            var orientation = extras.props.orientation || "";
            return getBorderRadiusByVariant(variant, orientation);
        }
    }
}), Image_Image = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, _trackImpression = _param.trackImpression, trackImpression = _trackImpression === void 0 ? !1 : _trackImpression, inViewThreshold = _param.inViewThreshold, source = _param.source, _enableZoom = _param.enableZoom, enableZoom = _enableZoom === void 0 ? !1 : _enableZoom, inProps = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "trackImpression",
        "inViewThreshold",
        "source",
        "enableZoom"
    ]);
    inProps.variant === "circle" && (inProps.height = inProps.width);
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,cjs.usePropsAndStyle)(inProps), 2), props = _$ref[0], style = _$ref[1];
    (0,react.useEffect)(function() {
        var imageRef = cjs.isWebTouchable && ref && "current" in ref ? ref.current : void 0;
        if (cjs.isWebTouchable && imageRef && enableZoom) {
            var imageElementScale = 1;
            var SCALE_MAX = 4, start = {
                x: 0,
                y: 0,
                distance: 0
            }, distance = function(event) {
                return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
            }, handleTouchStart = function(event) {
                event.touches.length === 2 && (event.preventDefault(), start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2, start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2, start.distance = distance(event));
            }, handleTouchMove = function(event) {
                if (event.touches.length === 2) {
                    event.preventDefault();
                    var scale;
                    (event === null || event === void 0 ? void 0 : event.scale) ? scale = event.scale : scale = distance(event) / start.distance, imageElementScale = Math.min(Math.max(1, scale), SCALE_MAX);
                    var deltaX = ((event.touches[0].pageX + event.touches[1].pageX) / 2 - start.x) * 2, deltaY = ((event.touches[0].pageY + event.touches[1].pageY) / 2 - start.y) * 2, transform = "translate3d(".concat(deltaX, "px, ").concat(deltaY, "px, 0) scale(").concat(imageElementScale, ")");
                    imageRef.style.transform = transform, imageRef.style.webkitTransform = transform, imageRef.style.zIndex = "9999", imageRef.style.transition = "ease 150ms";
                }
            }, handleTouchEnd = function() {
                imageRef.style.transform = "", imageRef.style.webkitTransform = "", imageRef.style.zIndex = "";
            };
            return imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchstart", handleTouchStart), imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchmove", handleTouchMove), imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchend", handleTouchEnd), function() {
                imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchstart", handleTouchStart), imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchmove", handleTouchMove), imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchend", handleTouchEnd);
            };
        }
    }, [
        ref,
        enableZoom
    ]);
    var BaseImageWithProps = /* @__PURE__ */ (0,jsx_runtime.jsx)(BaseImageReactNative, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        accessibilityLabel: props.alt,
        source: source,
        style: style,
        ref: ref
    }));
    return analyticsName && trackImpression ? /* @__PURE__ */ (0,jsx_runtime.jsx)(analytics/* ComponentWithViewTracking */.o, (0,_object_spread/* default */.Z)({
        Component: BaseImageWithProps,
        analyticsName: analyticsName,
        eventName: "imageViewEvent",
        inViewThreshold: inViewThreshold,
        ref: ref
    }, props)) : BaseImageWithProps;
});



/***/ }),

/***/ 61442:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(382526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(141817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(932165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(696649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(489554);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(491038);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(682772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(747042);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(396078);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(968309);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(209653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(319601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(833321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(369070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(438880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(749337);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(447941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(241539);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(974916);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(477601);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(339714);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(978783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(454747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(333948);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(667294);
/* harmony import */ var _chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(897375);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(624614);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(298352);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(626153);
/* harmony import */ var _system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(848189);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }


























var _excluded = ["aspectRatio", "fallbackSrc", "loading"],
  _excluded2 = ["analyticsName", "trackImpression"],
  _excluded3 = ["analyticsName"];
function cov_292sh6sq8e() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Image/Image.tsx";
  var hash = "c9a8c2c0a69bd9c54bbf29fe2d221e94190246f7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Image/Image.tsx",
    statementMap: {
      "0": {
        start: {
          line: 48,
          column: 18
        },
        end: {
          line: 73,
          column: 1
        }
      },
      "1": {
        start: {
          line: 50,
          column: 19
        },
        end: {
          line: 50,
          column: 49
        }
      },
      "2": {
        start: {
          line: 51,
          column: 21
        },
        end: {
          line: 51,
          column: 70
        }
      },
      "3": {
        start: {
          line: 52,
          column: 26
        },
        end: {
          line: 52,
          column: 45
        }
      },
      "4": {
        start: {
          line: 54,
          column: 19
        },
        end: {
          line: 54,
          column: 45
        }
      },
      "5": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 59,
          column: 14
        }
      },
      "6": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 31
        }
      },
      "7": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 71,
          column: 6
        }
      },
      "8": {
        start: {
          line: 63,
          column: 23
        },
        end: {
          line: 63,
          column: 42
        }
      },
      "9": {
        start: {
          line: 75,
          column: 26
        },
        end: {
          line: 80,
          column: 1
        }
      },
      "10": {
        start: {
          line: 77,
          column: 22
        },
        end: {
          line: 77,
          column: 95
        }
      },
      "11": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 71
        }
      },
      "12": {
        start: {
          line: 170,
          column: 14
        },
        end: {
          line: 176,
          column: 2
        }
      },
      "13": {
        start: {
          line: 171,
          column: 2
        },
        end: {
          line: 173,
          column: 3
        }
      },
      "14": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 100
        }
      },
      "15": {
        start: {
          line: 175,
          column: 2
        },
        end: {
          line: 175,
          column: 44
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        loc: {
          start: {
            line: 49,
            column: 60
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 49
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 55,
            column: 14
          },
          end: {
            line: 55,
            column: 15
          }
        },
        loc: {
          start: {
            line: 55,
            column: 20
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 55
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 63,
            column: 17
          },
          end: {
            line: 63,
            column: 18
          }
        },
        loc: {
          start: {
            line: 63,
            column: 23
          },
          end: {
            line: 63,
            column: 42
          }
        },
        line: 63
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        loc: {
          start: {
            line: 76,
            column: 57
          },
          end: {
            line: 79,
            column: 3
          }
        },
        line: 76
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 170,
            column: 44
          },
          end: {
            line: 170,
            column: 45
          }
        },
        loc: {
          start: {
            line: 170,
            column: 82
          },
          end: {
            line: 176,
            column: 1
          }
        },
        line: 170
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 51,
            column: 47
          },
          end: {
            line: 51,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 47
          },
          end: {
            line: 51,
            column: 58
          }
        }, {
          start: {
            line: 51,
            column: 62
          },
          end: {
            line: 51,
            column: 68
          }
        }],
        line: 51
      },
      "1": {
        loc: {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 171
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c9a8c2c0a69bd9c54bbf29fe2d221e94190246f7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_292sh6sq8e = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_292sh6sq8e();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







/**
 * Set of allowed aspect ratios defined by design.
 */

/**
 * NOTE ON METRIC TRACKING: Image is set up to track impression events
 * It will only track impression events if:
 *  1) a non-empty analyticsName is passed down
 *  2) the entirety of the image enters the viewport
 */

var BaseImage = (cov_292sh6sq8e().s[0]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__/* .forwardRef */ .Gp)(function (_ref, ref) {
  var aspectRatio = _ref.aspectRatio,
    fallbackSrc = _ref.fallbackSrc,
    loading = _ref.loading,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_292sh6sq8e().f[0]++;
  var styles = (cov_292sh6sq8e().s[1]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_28__/* .useStyleConfig */ .mq)('Image', props));
  var imgStyle = (cov_292sh6sq8e().s[2]++, _objectSpread(_objectSpread({}, styles), {}, {
    aspectRatio: (cov_292sh6sq8e().b[0][0]++, aspectRatio) || (cov_292sh6sq8e().b[0][1]++, 'auto')
  }));
  var _ref2 = (cov_292sh6sq8e().s[3]++, (0,react__WEBPACK_IMPORTED_MODULE_26__.useState)(props.src)),
    _ref3 = _slicedToArray(_ref2, 2),
    src = _ref3[0],
    setSrc = _ref3[1];
  var imgRef = (cov_292sh6sq8e().s[4]++, (0,react__WEBPACK_IMPORTED_MODULE_26__.useRef)());
  cov_292sh6sq8e().s[5]++;
  (0,react__WEBPACK_IMPORTED_MODULE_26__.useEffect)(function () {
    cov_292sh6sq8e().f[1]++;
    cov_292sh6sq8e().s[6]++;
    // Update ref src if onError fires during hydration - see bug:
    // https://github.com/facebook/react/issues/15446#issuecomment-484709466
    imgRef.current.src = src;
  }, [src]);
  cov_292sh6sq8e().s[7]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_29__/* .bricks.img */ .G.img, _extends({
    onError: function onError() {
      cov_292sh6sq8e().f[2]++;
      cov_292sh6sq8e().s[8]++;
      return setSrc(fallbackSrc);
    },
    ref: (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_30__/* .useMergeRefs */ .qq)(imgRef, ref)
    // __css has a lower priority than sx
    ,
    __css: imgStyle,
    loading: loading
  }, props, {
    src: src
  }));
}));
var ImageWithTracking = (cov_292sh6sq8e().s[9]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__/* .forwardRef */ .Gp)(function (_ref4, ref) {
  var analyticsName = _ref4.analyticsName,
    trackImpression = _ref4.trackImpression,
    props = _objectWithoutProperties(_ref4, _excluded2);
  cov_292sh6sq8e().f[3]++;
  var inViewRef = (cov_292sh6sq8e().s[10]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_31__/* .useTrackComponentInView */ .O)('imageViewEvent', trackImpression, analyticsName));
  cov_292sh6sq8e().s[11]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(BaseImage, _extends({
    ref: (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_30__/* .useMergeRefs */ .qq)(inViewRef, ref)
  }, props));
}));

/**
 * An image view displays a single image — or in some cases, an animated
 * sequence of images — on a transparent or opaque background.
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * Fallback (alternate) text to display when the image specified by the element
 * is not loaded. The `alt` attribute is officially mandatory; it's meant to
 * always be specified. If the image doesn't require a fallback (such as for an
 * image which is decorative or an advisory icon of minimal importance), you may
 * specify an empty string (""). See
 * [https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/alt](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/alt).
 *
 * ###
 *
 * Guidelines for `alt` tags:
 *
 * 1.  For both images and icons, if it's merely decorative, you don't need to
 * write `alt` text. Pass an empty string in these cases. You only need to add
 * it for ones that provide information or function.
 *
 * 2.  Highlight key things. You don't need to go into extreme detail.
 *
 * *   What's most noticeable?
 *
 * *   Who's in it?
 *
 * *   What are they doing?
 *
 * *   Where are they?
 *
 * 3.  You don't need to actually write "Image of" or "Picture of." That should
 * get auto-included by screen readers.
 *
 * 4.  For icons that provide function, you can include action/target here, too.
 * Some examples:
 *
 * *   Chat icon = Chat with an Opendoor Expert
 *
 * *   Menu icon = Open Menu / Open Settings
 *
 * *   Search icon = Search for homes
 *
 * *   Plus icon = Add person
 *
 * 5.  See o/glossary to verify that your labels match Opendoor's guidelines for
 * copy blocks.
 *
 *
 * ###
 *
 * ✅ Pass
 *
 * <Image src={homePhotoUrl} alt="The home at 125 W Muriel Dr, Phoenix, AZ
 * 85023" />
 *
 *
 * ###
 *
 * 🛑 Fail
 *
 * <Image src={homePhotoUrl} />
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Image` is set up to track impression events. It will only track impression
 * events if:
 *
 * 1.  a non-empty `analyticsName` is passed down (convention:
 * {appName}-{imageName})
 *
 * 2.  passing `trackImpression={true}` Image impression events will only be
 * tracked the first time that the image enters the viewport
 *
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_image\_view\_event for image
 * impression events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
var Image = (cov_292sh6sq8e().s[12]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__/* .forwardRef */ .Gp)(function (_ref5, ref) {
  var analyticsName = _ref5.analyticsName,
    props = _objectWithoutProperties(_ref5, _excluded3);
  cov_292sh6sq8e().f[4]++;
  cov_292sh6sq8e().s[13]++;
  if (analyticsName) {
    cov_292sh6sq8e().b[1][0]++;
    cov_292sh6sq8e().s[14]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(ImageWithTracking, _extends({
      alt: props.alt,
      analyticsName: analyticsName,
      ref: ref
    }, props));
  } else {
    cov_292sh6sq8e().b[1][1]++;
  }
  cov_292sh6sq8e().s[15]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(BaseImage, _extends({
    ref: ref
  }, props));
}));
/* harmony default export */ __webpack_exports__["Z"] = (Image);

/***/ })

}]);